// For Footer menu

$(document).ready(function() {
  var w=$(window).width();
  if (w < 575 ){
    $('.footer .thb-widget-title').click(function() {
        $(this).next().slideToggle("slow");
      	$(this).toggleClass("open-menu");
    });
  }
   setTimeout(function() {
    $('.spr-reviews').flickity({
      // options
      contain: true,
      autoPlay: true,
      groupCells: 3,
      pageDots: false
      });
  }, 2500);

// $('.press-module-inner ul').flickity({
//   // options
//   freeScroll: true,
//   contain: true,
//   prevNextButtons: false,
//   pageDots: true,
//   groupCells: '4',
//   autoPlay: true,
// });

$('.image-slider-inner').flickity({
  // options
  freeScroll: true,
  contain: true,
  prevNextButtons: true,
  pageDots: false,
  autoPlay: true,
  wrapAround: true,
});
// 1st carousel, main
$('.value-slider-main .slider-inner').flickity({
  contain: true,
  pageDots: true,
  prevNextButtons: false,
});
  
// 2nd carousel, navigation
$('.value-slider-nav').flickity({
  asNavFor: '.slider-inner',
  contain: false,
  pageDots: false,
  prevNextButtons: false,
  groupCells: '4'
});
  
var timer = setInterval(function(){
  if($(".usf-pro-wraper").length > 0){
    $(".usf-pro-wraper").each(function(){
      var pro_color = $(this).find(".usf-title").children("a").text();
      $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
    });
    clearInterval(timer);
  }
},200);

var timer_load = setInterval(function(){
    if($(".usf-load-more").length > 0){
       $(".usf-load-more").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load);
    }
  },200);
  
    var timer_load1 = setInterval(function(){
    if($(".usf-btn.usf-relative").length > 0){
       $(".usf-btn.usf-relative").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load1);
    }
  },200);

   var timer_load2 = setInterval(function(){
    if($(".usf-refineby__item").length > 0){
        debugger
       $(".usf-refineby__item").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load2);
    }
  },200);

var timer_load3 = setInterval(function(){
    if($(".usf-clear-all.usf-btn").length > 0){
        debugger
       $(".usf-clear-all.usf-btn").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load3);
    }
  },200);

});
$("input[data-name=Color]").change(function(){
  console.log($(this).val());
  if ($(this).val() == 'Periwinkle') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#c4c0de');
  }else if ($(this).val() == 'Blue') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#176fdb');
  }else if ($(this).val() == 'Lavender') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#d2a3d9');
  }else if ($(this).val() == 'Mint') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#b2dbc2');
  }else if ($(this).val() == 'Gold') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#e7dbcc');
  }else if ($(this).val() == 'Orchid') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#e5a3b0');
  }else if ($(this).val() == 'Aqua') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#7ad4cf');
  }else if ($(this).val() == 'Silver') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#c9c8c8');
  }else if ($(this).val() == 'Indigo') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#31516d');
  }else if ($(this).val() == 'White') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#ebebeb');
  }
  else {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  $(this).val());
  }
});

$(document).ready(function() {
$('.press-module-inner ul').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        slidesToShow: 2,
      }
    },
  ]
});
  
  // product-text-slider
  
  $('.product-text-slider .pts-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
  });
});
$(document).ready(function() {
  var maxHeight = 0;
  $(".eq-height>div:not(.rb-btn)").each(function(){
     if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".eq-height>div:not(.rb-btn)").height(maxHeight);
});
$(document).ready(function(){
  $('a.flip-btn').on('click', function () {
    $(this).parent().parent().parent().find('.card, .rb-btn').toggleClass('flipped');
  });
  $('a.flips-btn').on('click', function () {
    $(this).parent().toggleClass('flipped');
  });
});

$(function() {
    $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
    $('.video-popup').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
});

// for tab js

function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent-cus");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks-cus");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
if (document.getElementById("tab-cus-active") != null) {
  document.getElementById("tab-cus-active").click();
}
